import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgFlagUsaGlyph(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "M8 13v22h32V13H8Zm30.843 1.179v2.75H22.458v-2.75h16.385ZM22.458 25.57v-3.044h16.385v3.044H22.458Zm16.385 1.277v3.045H9.157v-3.045h29.686ZM22.458 21.25v-3.045h16.385v3.045H22.458ZM9.157 14.179h12.048V25.57H9.157V14.18Zm0 19.544v-2.652h29.686v2.652H9.157Z",
    fill: "currentColor"
  }), jsx("path", {
    d: "M11.759 17.223c.32 0 .578-.264.578-.59a.584.584 0 0 0-.578-.588.584.584 0 0 0-.578.589c0 .325.259.59.578.59ZM15.229 17.223c.32 0 .578-.264.578-.59a.584.584 0 0 0-.578-.588.584.584 0 0 0-.578.589c0 .325.258.59.578.59ZM18.699 17.223c.32 0 .578-.264.578-.59a.584.584 0 0 0-.578-.588.584.584 0 0 0-.579.589c0 .325.26.59.579.59ZM11.759 20.66c.32 0 .578-.263.578-.589a.584.584 0 0 0-.578-.589.584.584 0 0 0-.578.59c0 .325.259.589.578.589ZM15.229 20.66c.32 0 .578-.263.578-.589a.584.584 0 0 0-.578-.589.584.584 0 0 0-.578.59c0 .325.258.589.578.589ZM18.699 20.66c.32 0 .578-.263.578-.589a.584.584 0 0 0-.578-.589.584.584 0 0 0-.579.59c0 .325.26.589.579.589ZM11.759 24.098c.32 0 .578-.264.578-.59a.584.584 0 0 0-.578-.588.584.584 0 0 0-.578.589c0 .325.259.59.578.59ZM15.229 24.098c.32 0 .578-.264.578-.59a.584.584 0 0 0-.578-.588.584.584 0 0 0-.578.589c0 .325.258.59.578.59ZM18.699 24.098c.32 0 .578-.264.578-.59a.584.584 0 0 0-.578-.588.584.584 0 0 0-.579.589c0 .325.26.59.579.59Z",
    fill: "currentColor"
  }));
}

export { SvgFlagUsaGlyph as default };
